module.exports = __webpack_public_path__ + "media/images/new-ui-images/share-icon-f6e7d0649e1438e6e34103de608b98cd.svg";